@if (!carregando) {
  <div class="venda-interna-gerencial-page" [@esvanecerDesvanecer]="'in'">
    <div class="venda-interna-gerencial-topbar">
      <div>
        <h1>Venda Interna Gerencial</h1>
        <span>Dados do dia atual - {{ dataAtual | date: 'dd/MM/yyyy HH:mm' }}</span>
      </div>

      <div class="venda-interna-gerencial-actions">
        <label>
          <span>Ordenar por</span>
          <select [(ngModel)]="ordenacao" [ngModelOptions]="{standalone: true}">
            <option value="vendas">Vendas</option>
            <option value="realizadas">Realizadas</option>
            <option value="ganho">Ganho %</option>
            <option value="total">Total atendimentos</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="ligacoes">Ligacoes</option>
          </select>
        </label>
        <button type="button" (click)="atualizar()">Atualizar</button>
      </div>
    </div>

    <div class="venda-interna-gerencial-summary">
      <div class="venda-interna-gerencial-summary-card">
        <span>Total de ligacoes</span>
        <strong>{{ resumo.totalLigacoes | number: '1.0-0' }}</strong>
        <small>{{ resumo.totalRealizadas | number: '1.0-0' }} realizadas</small>
      </div>
      <div class="venda-interna-gerencial-summary-card">
        <span>Total WhatsApp</span>
        <strong>{{ resumo.totalWhatsapp | number: '1.0-0' }}</strong>
        <small>{{ resumo.totalWhatsappAtendimento | number: '1.0-0' }} em atendimento ou finalizados</small>
      </div>
      <div class="venda-interna-gerencial-summary-card">
        <span>Total atendimentos</span>
        <strong>{{ resumo.totalAtendimentos | number: '1.0-0' }} / {{ resumo.totalRealizadas + resumo.totalWhatsappAtendimento | number: '1.0-0' }}</strong>
        <small>total / realizados · ligações + WhatsApp</small>
      </div>
      <div class="venda-interna-gerencial-summary-card">
        <span>Vendas</span>
        <strong>{{ resumo.totalVendas | currency: 'BRL' }}</strong>
        <small>{{ resumo.totalPedidos | number: '1.0-0' }} pedidos</small>
      </div>
      <div class="venda-interna-gerencial-summary-card">
        <span>Litros</span>
        <strong>{{ resumo.totalLitros | number: '1.0-0' }} L</strong>
        <small>pedidos do dia</small>
      </div>
      <div class="venda-interna-gerencial-summary-card">
        <span>Ganho geral</span>
        <strong>{{ resumo.percentualGanhoGeral | number: '1.1-1' }}%</strong>
        <small>{{ resumo.totalGanhos | number: '1.0-0' }} ganhos sobre {{ resumo.totalRealizadas + resumo.totalWhatsappAtendimento | number: '1.0-0' }} realizados</small>
      </div>
      <div class="venda-interna-gerencial-summary-card">
        <span>Nao comprou / perda</span>
        <strong>{{ resumo.totalPerdas | number: '1.0-0' }}</strong>
        <small>realizados − ganhos</small>
      </div>
    </div>

    <div class="venda-interna-gerencial-grid">
      @for (vendedor of vendedoresOrdenados(); track vendedor.sellerId) {
        <article class="venda-interna-gerencial-card">
          <div class="venda-interna-gerencial-card-head">
            <div class="venda-interna-gerencial-avatar-box" [ngClass]="tierGanho(vendedor.percentualGanhoGeral)">
              <div class="venda-interna-gerencial-avatar-ring"></div>
              <img class="venda-interna-gerencial-avatar" [src]="foto(vendedor)" [alt]="vendedor.nome" />
              @if (resumo.podeAtualizarFotos) {
                <label class="venda-interna-gerencial-photo-button" title="Atualizar foto">
                  <i class="fa fa-camera"></i>
                  <input type="file" accept="image/*" (change)="selecionarFoto($event, vendedor)" />
                </label>
              }
            </div>
            <div>
              <h2>{{ vendedor.nome }}</h2>
            </div>
            <div class="venda-interna-gerencial-card-total">
              <span>Ganho geral</span>
              <strong [ngClass]="tierGanho(vendedor.percentualGanhoGeral)">{{ vendedor.percentualGanhoGeral | number: '1.1-1' }}%</strong>
            </div>
          </div>

          <div class="venda-interna-gerencial-card-body">
            <div class="venda-interna-gerencial-metrics">
              <div class="venda-interna-gerencial-metric">
                <span>Ligacoes</span>
                <strong>{{ vendedor.totalLigacoes | number: '1.0-0' }} / {{ vendedor.totalRealizadas | number: '1.0-0' }}</strong>
                <small>total / realizadas</small>
              </div>
              <div class="venda-interna-gerencial-metric venda-interna-gerencial-metric-whatsapp">
                <span>WhatsApp</span>
                <strong>{{ vendedor.totalWhatsapp | number: '1.0-0' }} / {{ vendedor.whatsappAtendimento | number: '1.0-0' }}</strong>
                <small>total / realizados</small>
              </div>
              <div class="venda-interna-gerencial-metric venda-interna-gerencial-metric-total">
                <span>Totalizador</span>
                <strong>{{ vendedor.totalAtendimentos | number: '1.0-0' }} / {{ vendedor.totalRealizadas + vendedor.whatsappAtendimento | number: '1.0-0' }}</strong>
                <small>total / realizados</small>
              </div>
              <div class="venda-interna-gerencial-metric venda-interna-gerencial-metric-green">
                <span>Ganho</span>
                <strong>{{ vendedor.totalGanhos | number: '1.0-0' }}</strong>
                <small>{{ vendedor.percentualGanhoGeral | number: '1.1-1' }}% dos realizados</small>
              </div>
              <div class="venda-interna-gerencial-metric venda-interna-gerencial-metric-green">
                <span>Vendas R$</span>
                <strong>{{ vendedor.vendas | currency: 'BRL' }}</strong>
                <small>{{ vendedor.pedidos | number: '1.0-0' }} pedidos do dia</small>
              </div>
              <div class="venda-interna-gerencial-metric venda-interna-gerencial-metric-green">
                <span>Litros</span>
                <strong>{{ vendedor.litros | number: '1.0-0' }} L</strong>
                <small>volume vendido</small>
              </div>
            </div>

            <div class="venda-interna-gerencial-origin">
              <div class="venda-interna-gerencial-origin-title">
                <span>Origem</span>
                <span>Total</span>
                <span>%</span>
                <span>Progresso</span>
              </div>

              <div class="venda-interna-gerencial-origin-row">
                <span class="venda-interna-gerencial-tag venda-interna-gerencial-tag-blue">Agendado</span>
                <b>{{ vendedor.totalAgendado | number: '1.0-0' }} / {{ vendedor.realizadoAgendado | number: '1.0-0' }}</b>
                <b>{{ vendedor.percentualAgendado | number: '1.1-1' }}%</b>
                <div class="venda-interna-gerencial-bar"><i class="blue" [style.width.%]="largura(vendedor.percentualAgendado)"></i></div>
              </div>

              <div class="venda-interna-gerencial-origin-row">
                <span class="venda-interna-gerencial-tag venda-interna-gerencial-tag-purple">Gerado</span>
                <b>{{ vendedor.totalGerado | number: '1.0-0' }} / {{ vendedor.realizadoGerado | number: '1.0-0' }}</b>
                <b>{{ vendedor.percentualGerado | number: '1.1-1' }}%</b>
                <div class="venda-interna-gerencial-bar"><i class="purple" [style.width.%]="largura(vendedor.percentualGerado)"></i></div>
              </div>

              <div class="venda-interna-gerencial-origin-row">
                <span class="venda-interna-gerencial-tag venda-interna-gerencial-tag-orange">Manual</span>
                <b>{{ vendedor.totalManual | number: '1.0-0' }} / {{ vendedor.realizadoManual | number: '1.0-0' }}</b>
                <b>{{ vendedor.percentualManual | number: '1.1-1' }}%</b>
                <div class="venda-interna-gerencial-bar"><i class="orange" [style.width.%]="largura(vendedor.percentualManual)"></i></div>
              </div>

              <div class="venda-interna-gerencial-origin-row">
                <span class="venda-interna-gerencial-tag venda-interna-gerencial-tag-cyan">WhatsApp</span>
                <b>{{ vendedor.totalWhatsapp | number: '1.0-0' }} / {{ vendedor.whatsappAtendimento | number: '1.0-0' }}</b>
                <b>{{ percentual(vendedor.whatsappAtendimento, vendedor.totalWhatsapp) | number: '1.1-1' }}%</b>
                <div class="venda-interna-gerencial-bar"><i class="cyan" [style.width.%]="largura(percentual(vendedor.whatsappAtendimento, vendedor.totalWhatsapp))"></i></div>
              </div>
            </div>

          </div>
        </article>
      }
    </div>
  </div>
}

@if (carregando) {
  <div class="venda-interna-gerencial-loading">Carregando Venda Interna Gerencial...</div>
}
